export const isProduction = (): boolean => {
  return window.location.href.includes("app.greenometer.com");
};
